













































import { Component, Mixins } from 'vue-property-decorator';
import SectionTitle from '@rogues/SectionTitle/shared/sectionTitle';

@Component({
    components: {
    },
})
/**
 * @name Bordered
 */
export default class Bordered extends Mixins(SectionTitle) {}
